// Libs
import { useAtomValue } from 'jotai';

// Hooks
import usePosts from '@/utils/hooks/giveaway-picker/usePosts';

import { NO_BACKGROUND } from '@/components/base/Button';
import LoadMoreButton from '@/components/composite/Button/LoadMoreButton';
// Atoms
import { socialProfileAtom } from '@/components/pages/giveaway-picker/Atoms/socialProfileAtom';

export const Pagination = () => {
    const selectedProfile = useAtomValue(socialProfileAtom);
    const { loadMore, isLoadingMore, isLoadMore } = usePosts(selectedProfile?.id);

    if (!isLoadMore) {
        return null;
    }

    return (
        <div
            className="mb-2 mt-8 flex items-center justify-center gap-4"
            data-testid="load-more-button">
            <LoadMoreButton
                loadMoreItems={loadMore}
                isLoadingMore={isLoadingMore}
                isAutoLoadEnabled={false}
                variant={NO_BACKGROUND}
            />
        </div>
    );
};
